<template>
  <div class="voice-select" v-outside-click="handleOutside">
    <!-- 선택된 값 -->
    <button class="voice-select__trigger" @click="isOpenSelectList = !isOpenSelectList">
      <template v-if="selectedVoice">
        <img class="voice-select__avatar" :src="selectedVoice.imgUrl" alt="" />
        <div class="voice-select__info">
          <strong class="voice-select__name">{{ selectedVoice.name }}</strong>
          <span class="voice-select__tag" :class="getVibeClass(selectedVoice.vibeKey)">{{ selectedVoice.vibe }}</span>
          <span class="voice-select__tag voice-select__tag--tone">{{ selectedVoice.tone }}</span>
        </div>

        <IconDown class="voice-select__arrow" />
      </template>
    </button>

    <!-- 옵션 리스트 -->
    <div class="voice-select__list-wrapper" v-if="isOpenSelectList">
      <ul class="voice-select__list">
        <li class="voice-select__item" v-for="voiceItem in options" :key="voiceItem.brandMusicId" @click="onClickSelectVoice(voiceItem)">
          <!-- 왼쪽 프로필 -->
          <div class="voice-select__profile">
            <div class="voice-select__avatar-wrap">
              <div class="voice-option__check" v-if="selectedVoice && selectedVoice.optionNo === voiceItem.optionNo">
                <IconCheck />
              </div>
              <img class="voice-select__avatar--lg" :src="voiceItem.imgUrl" alt="" />
            </div>

            <div class="voice-select__info">
              <strong class="voice-select__name">{{ voiceItem.name }}</strong>
              <span class="voice-select__tag" :class="getVibeClass(voiceItem.vibeKey)">{{ voiceItem.vibe }}</span>
              <span class="voice-select__tag voice-select__tag--tone">{{ voiceItem.tone }}</span>
            </div>
          </div>
          <!-- 오른쪽 액션 -->
          <div class="voice-select__actions">
            <button class="voice-select__play-btn" :class="voiceItem.isActive ? 'is-active' : ''" @click.stop="onClickPreview(voiceItem)">
              <!-- 중지 상태 -->
              <IconPlayFill v-if="!voiceItem.isActive" />

              <div class="preview-icon" v-else-if="voiceItem.isActive">
                <!-- 재생중 hover -->
                <IconPauseFill class="icon-pause" />
                <!-- 재생중 not hover-->
                <div class="equalizer">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import IconDown from '@/assets/icons/icon-down.svg';
import IconPlayFill from '@/assets/icons/icon-play-fill-dark.svg';
import IconPauseFill from '@/assets/icons/icon-pause-fill.svg';
import IconCheck from '@/assets/icons/icon-check.svg';
import { AIVOICE_AUDIO_TYPE } from '@/constants/aivoiceConstants';
export default {
  props: {
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isPlay: {
      type: Boolean,
      default: false,
    },
    selectedVoice: {
      type: Object,
      default: null,
    },
    playingType: {
      type: String,
      default: null, // preview, content, null
    },
  },
  emits: ['voice-change', 'preview'],
  data() {
    return {
      isOpenSelectList: false,
      AIVOICE_AUDIO_TYPE,
    };
  },
  components: {
    IconDown,
    IconPlayFill,
    IconPauseFill,
    IconCheck,
  },
  methods: {
    handleOutside() {
      this.isOpenSelectList = false;
    },
    getVibeClass(vibe) {
      const map = {
        TRUST: 'voice-select__tag--trust',
        WARM: 'voice-select__tag--warm',
        CALM: 'voice-select__tag--calm',
        FRIENDLY: 'voice-select__tag--friendly',
      };

      return map[vibe] || '';
    },
    onClickSelectVoice(item) {
      this.$emit('voice-change', item);
      this.isOpenSelectList = false;
    },
    onClickPreview(item) {
      this.$emit('voice-change', item);
      this.$emit('preview', AIVOICE_AUDIO_TYPE.PREVIEW, item);
    },
  },
};
</script>
<style scoped>
.voice-select {
  position: relative;
}

button.voice-select__trigger {
  width: 100%;
  border-radius: 8px;
  padding: 11px 16px;
  border: 1px solid #ffffff33;
  background-color: #393939;
  display: flex;
  align-items: center;
}

img.voice-select__avatar {
  width: 28px;
  aspect-ratio: 1/1;
}

.voice-select__avatar-wrap {
  position: relative;
}
img.voice-select__avatar--lg {
  width: 48px;
  height: 48px;
}

.voice-select__info {
  display: flex;
  gap: 8px;
  margin-left: 12px;
}

strong.voice-select__name {
  color: #ffffff;
  font-size: 16px;
  line-height: 20px;
  font-weight: 400;
}

.voice-select__tag {
  background-color: transparent;
  font-size: 12px;
  line-height: 1;
  padding: 0px 4px;
  font-weight: 500;
  display: flex;
  border-radius: 4px;
  align-items: center;
}
/* 신뢰감 */
.voice-select__tag--trust {
  background-color: #e9e4ff;
  color: #6c4eff;
}

/* 다정함 */
.voice-select__tag--warm {
  background-color: #ffe8d9;
  color: #ff7a00;
}

/* 차분함 */
.voice-select__tag--calm {
  background-color: #e3f2ff;
  color: #1e88e5;
}

/* 친숙함 */
.voice-select__tag--friendly {
  background-color: #e6f7ea;
  color: #2ead4b;
}

/* 톤(낮은톤, 중간톤, 높은톤) */
.voice-select__tag--tone {
  background-color: #4a4a4a;
  color: #bdbdbd;
}

.voice-select__arrow {
  margin-left: auto;
}

.voice-select__list-wrapper {
  height: auto;
  display: block;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  margin-top: 8px;
  background: #393939;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  border: 1px solid #ffffff33;
  padding: 8px 4px 8px 0;
}

.voice-select__list {
  width: 100%;

  max-height: 278px;
  overflow-y: auto;
  list-style: none;
}

.voice-select__list::-webkit-scrollbar {
  width: 4px;
  display: block;
}

.voice-select__list::-webkit-scrollbar-track {
  background: transparent;
}

.voice-select__list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 10px;
}

.voice-select__list::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

.voice-select__item {
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 12px 16px;
  cursor: pointer;
}

.voice-select__item:hover {
  background-color: #323232;
}

.voice-select__profile {
  display: flex;
  align-items: center;
}

.voice-select__play-btn {
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
.voice-select__play-btn.is-active {
  background-color: #ff3355;
}

.voice-select__play-btn:hover {
  background-color: #c4c4c4;
}
.voice-select__play-btn.is-active:hover {
  background-color: #ff3355;
}

.preview-icon {
  position: relative;
  width: 24px;
  height: 24px;
}
/* 기본: pause 아이콘 숨김 */
.icon-pause {
  display: none;
}
.equalizer {
  width: 24px;
  height: 24px;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
}

/* hover 시 전환 */
.preview-icon:hover .icon-pause {
  display: block;
}
.preview-icon:hover .equalizer {
  display: none;
}
.equalizer div {
  width: 2px;
  height: 0px;
  border-radius: 2px;
  background: white;

  animation: equalize 1s ease-in-out infinite;
}

/* 각각 딜레이 다르게 */
.equalizer div:nth-child(1) {
  animation-delay: 0s;
}
.equalizer div:nth-child(2) {
  animation-delay: 0.2s;
}
.equalizer div:nth-child(3) {
  animation-delay: 0.4s;
}
.equalizer div:nth-child(4) {
  animation-delay: 0.6s;
}

@keyframes equalize {
  0% {
    height: 6px;
  }
  50% {
    height: 14px;
  }
  100% {
    height: 6px;
  }
}

.voice-option__check {
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>
